/* global newrelic */
import { podFulFillmentUtils } from '@thd-olt-component-react/fulfillment';

export const iconUrl = 'https://assets.thdstatic.com/images/v1/product-hotspot.svg';
const closeUrl = 'https://assets.thdstatic.com/images/v1/close-symbol-orange.svg';

const isUniqueHotspot = (uniqueHotspotItemIDs, itemId) => {
  return itemId && uniqueHotspotItemIDs.indexOf(itemId) === -1;
};

export const getHotspotDetails = (hotspots = []) => {
  const uniqueHotspots = [];
  const uniqueHotspotItemIDs = [];
  if (hotspots?.length) {
    hotspots.forEach((hotspot) => {
      const { itemId } = hotspot;
      if (isUniqueHotspot(uniqueHotspotItemIDs, itemId)) {
        uniqueHotspotItemIDs.push(itemId);
        uniqueHotspots.push(hotspot);
      }
    });
  }

  return uniqueHotspots;
};

const deselectHotspot = (container, img) => {
  const tempContainer = container;
  tempContainer.className = 'tag';
  img.setAttribute('src', iconUrl);
};

const deselectPreviousHotspot = (container) => {
  const activeHotspots = [
    ...document.getElementsByClassName('tag tippy-active')
  ];
  const previouslySelected = activeHotspots.find((hotspot) => hotspot !== container);
  if (previouslySelected) {
    deselectHotspot(previouslySelected, previouslySelected.children[1]);
  }
};

const selectHotspot = (container, img) => {
  const tempContainer = container;
  img.setAttribute('src', closeUrl);
  tempContainer.className = 'tag tippy-active';
};

export const toggleActiveClass = (event) => {
  const container = event?.currentTarget;
  const img = container?.children[1];
  const notSelected = container?.getAttribute('aria-expanded') === 'false';

  if (notSelected) {
    deselectPreviousHotspot(container);
    selectHotspot(container, img);
  } else {
    const timeToWait = 300;
    // Allow time for the tooltip to close so that deselection of hotspot is synchronized
    setTimeout(() => {
      deselectHotspot(container, img);
    }, timeToWait);
  }
};

export const imageStyle = (hsXPosition, hsYPosition) => {
  return {
    cursor: 'pointer',
    left: `${hsXPosition * 100}%`,
    top: `${hsYPosition * 100}%`
  };
};

export const triggerAnalytics = (name, value) => {
  LIFE_CYCLE_EVENT_BUS.trigger(name, value);
};

export const getProductInfo = (container, productPrice) => {
  const itemId = container?.itemId;
  const brandName = container?.identifiers?.brandName;
  const productLabel = container?.identifiers?.productLabel;
  const canonicalUrl = container?.identifiers?.canonicalUrl;
  const averageRating = container?.reviews?.ratingsReviews?.averageRating || 0;
  const totalReviews = container?.reviews?.ratingsReviews?.totalReviews || 0;
  const images = container?.media?.images;
  const [productImage] = images || [];

  return {
    itemId,
    averageRating,
    brandName,
    imageUrl: productImage?.url || '',
    productLabel,
    productUrl: canonicalUrl,
    totalReviews,
    price: productPrice ? `${productPrice}`.split('.') : ''
  };
};
export const isProductOutOfStockOnline = (product = {}) => {
  const isBODFS = podFulFillmentUtils.isBODFS(product);
  const isBOPIS = podFulFillmentUtils.isBOPIS(product);
  const isOutOfStock = podFulFillmentUtils.isOutOfStockOnline(product);
  const isOOS = isOutOfStock && !(isBOPIS || isBODFS);
  return isOOS;
};

export const getProductAvailability = (product) => {
  let unfulfillable = false;
  const productLoaded = product && Object.keys(product)?.length !== 0;
  if (productLoaded) {
    const isBODFS = podFulFillmentUtils.isBODFS(product);
    const isBOPIS = podFulFillmentUtils.isBOPIS(product);
    const isSTH = podFulFillmentUtils.isSTH(product) && !podFulFillmentUtils.getExcludedStateSth(product);
    const isBOSS = podFulFillmentUtils.isBOSS(product);
    const isOOS = isProductOutOfStockOnline(product);
    const isFulfillable = podFulFillmentUtils.isFulfillable(product);
    const noFulfillment = !isBODFS && !isSTH && !isBOPIS && !isBOSS;
    const isCurrentlyUnavailable = podFulFillmentUtils.isCurrentlyUnavailable(product);
    const isDiscontinued = podFulFillmentUtils.isDiscontinued(product);

    if (!isFulfillable
      || isOOS
      || noFulfillment
      || isCurrentlyUnavailable
      || isDiscontinued
    ) {
      unfulfillable = true;
    }
  }

  return {
    unfulfillable
  };
};

export const removeActiveClass = (event, hotspotRef, onClick) => {
  const targetId = event?.currentTarget?.id;
  const parentId = event?.currentTarget?.parentNode?.id;
  const eventClassName = event?.target?.className;
  const parentContainer = document.querySelector('.thd-react-tooltip__content ');
  const tooltipContainer = parentContainer?.contains(event.target);
  const clickedOutsideTag = targetId !== 'hotspot-container' && parentId !== 'hotspot-container'
    && !tooltipContainer;
  const active = hotspotRef && hotspotRef.current && hotspotRef.current.className === 'tag tippy-active';
  if (clickedOutsideTag && active) {
    // if the user clicks outside of the tag, we want to close the tooltip
    if ((eventClassName !== 'icon' && eventClassName !== 'tag tippy-active')
      && eventClassName.indexOf('details') === -1) {
      let hotspotRefTemp = hotspotRef.current;
      hotspotRefTemp = null;
      if (onClick) onClick(event, hotspotRefTemp);
    }
    const container = hotspotRef.current;
    const img = hotspotRef.current.children[1];
    const timeToWait = 150;
    // Allow time for the tooltip to close so that deselection of hotspot is synchronized
    setTimeout(() => {
      deselectHotspot(container, img);
    }, timeToWait);
  }
};

export const getFilteredProduct = (products, imageURL) => {
  const inStockProducts = (products || []).filter((product) => {
    return !getProductAvailability(product).unfulfillable;
  });
  if (!inStockProducts.length) {
    // Trigger a newrelic event when all the products are unfulfillable.
    if (window && typeof window.newrelic !== 'undefined' && window.newrelic.addPageAction) {
      const omsIDs = products.map((product) => product.itemId).join();
      window.newrelic.addPageAction('PIPOOSHotspots', {
        omsIDs,
        imageURL
      });
    }
    return [products[0]];
  }
  return inStockProducts;
};